import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core'
import {BrowserModule} from '@angular/platform-browser'
import {RouteReuseStrategy} from '@angular/router'
import {HttpClient, provideHttpClient, withInterceptors} from '@angular/common/http'

import {IonicModule, IonicRouteStrategy} from '@ionic/angular'
import {IonicConfig} from '@ionic/core';
import {AppRoutingModule} from './app-routing.module'
import {AppComponent} from './app.component'
import {TranslateModule, TranslateLoader} from '@ngx-translate/core'
import {HttpLoaderFactory} from './translate-loader'
import {ComponentsModule} from './components/components.module'
import {TranslateConfigService} from './services/translate-config.service'
import {LocaleService} from './services/locale.service'
import {LocalDatePipe} from './pipes/local-date.pipe'
import {initializeApp, provideFirebaseApp} from "@angular/fire/app";
import {environment} from "../environments/environment";
import {getAuth, provideAuth} from "@angular/fire/auth";
import {authInterceptor} from './interceptors/auth.interceptor';


const config: IonicConfig = {
  innerHTMLTemplatesEnabled: true
};

@NgModule({
  declarations: [AppComponent],
    imports: [
        BrowserModule,
        LocalDatePipe,
        IonicModule.forRoot(config),
        AppRoutingModule,
        ComponentsModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
    ],
  providers: [
    {provide: RouteReuseStrategy, useClass: IonicRouteStrategy},
  TranslateConfigService,
  LocaleService,
  
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => getAuth()),
    provideHttpClient(withInterceptors([authInterceptor])),
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {
  constructor(private translateConfigService: TranslateConfigService) {
    // El servicio se encargará de inicializar el idioma correcto
  }
}
